import type { IconProps } from "@/components/Icons/index";

/** From `public/assets/images/figma/sidebar-intelligence.svg` — `viewBox="0 0 14 14"`. */
export const SidebarIntelligenceIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0 11.1838C0 11.4945 0.123175 11.7884 0.341532 12.0096L1.9904 13.6585C2.20876 13.8768 2.5055 14 2.81624 14H3.4993V5.24895H0V11.1838Z"
      fill="currentColor"
    />
    <path
      d="M13.6557 1.9904L12.0068 0.341532C11.7885 0.123175 11.4917 0 11.181 0H10.4979V8.74825H13.9972V2.81624C13.9972 2.5055 13.874 2.21156 13.6557 1.9904Z"
      fill="currentColor"
    />
    <path
      d="M5.25175 10.4979V13.9972H11.1838C11.4945 13.9972 11.7884 13.874 12.0096 13.6557L13.6585 12.0068C13.8768 11.7884 14 11.4917 14 11.181V10.4979H5.25175Z"
      fill="currentColor"
    />
    <path
      d="M8.74825 3.4993V0H2.81624C2.5055 0 2.21156 0.123175 1.9904 0.341532L0.341532 1.9904C0.123175 2.20876 0 2.5055 0 2.81624V3.4993H8.74825Z"
      fill="currentColor"
    />
  </svg>
);
